// 计算机所有的数据在存储、运算、传输时都要用二进制表示

// 二进制由 0 和 1 组成

// 字节：计算机数据的基本长度单位，每个字节占 8 位二进制

// ASCII：0xxxxxxx
// 扩展 ASCII：1xxxxxxx

// Unicode 万国码/统一码 计算机业界标准
//
// 平面：每个平面可存放 65536（2^16）个字符；共 17（2^5）个平面；整个字符集大小是 2^21；范围：U+000000 ~ U+10FFFF
//    基本平面（BMP），存常用字符，范围：U+0000 ~ U+FFFF。存在空段：U+D800 ~ U+DFFF
//    辅助平面（SMP），存其它字符，范围：U+010000 ~ U+10FFFF

const Unicode = {}

// 获取字符串的 Unicode 编码列表
Unicode.fromString = str => {
  const codes = []
  for (const i in str) {
    codes.push(str.charCodeAt(i))
  }
  return codes
}

// 根据 Unicode 编码获取字符串
Unicode.toString = codes => String.fromCharCode(...codes)

// 获取 Unicode 单字节数组
Unicode.split = code => {
  const codes = []
  do {
    codes.unshift(code & 0xff)
    code >>= 8
  } while (code)
  return codes
}

export default Unicode
